import type { Stage, StageState } from '@aeon-karaoke/cloud-convex/model/pipelineStages';
import { MonoLabel, StatusDot, type StatusTone } from '@/component';
import { cn } from '@/lib/cn';

const DOT = {
  Done: 'ready',
  Working: 'preparing',
  Waiting: 'idle',
  Failed: 'attention',
  Skipped: 'idle',
} satisfies Record<StageState, StatusTone>;

const LABEL = {
  Done: 'text-mute',
  Working: 'text-ink',
  Waiting: 'text-faint',
  Failed: 'text-ink',
  Skipped: 'text-faint',
} satisfies Record<StageState, string>;

const STATE = {
  Done: 'up',
  Working: 'acc',
  Waiting: 'faint',
  Failed: 'down',
  Skipped: 'faint',
} as const satisfies Record<StageState, 'up' | 'acc' | 'faint' | 'down'>;

/** The four-stage pipeline list. The dot transitions in place and the state
 * label fades in when it changes; both are still under reduced motion. */
export function CreatePipeline({ stages, compact = false }: { stages: Stage[]; compact?: boolean }) {
  return (
    <div>
      {stages.map((stage) => (
        <div
          key={stage.key}
          className={cn('flex items-center gap-4 border-b border-stripeA', compact ? 'py-3' : 'py-[14px]')}
        >
          <StatusDot tone={DOT[stage.state]} />
          <span className={cn('flex-1', compact ? 'text-sm' : 'text-[15px]', LABEL[stage.state])}>{stage.label}</span>
          <MonoLabel key={stage.state} tone={STATE[stage.state]} className="label-fade">
            {stage.state}
          </MonoLabel>
        </div>
      ))}
    </div>
  );
}
